<template>
  <v-card>
    <v-sheet color="#f3f5f6">
      <v-card-title class="d-flex flex-column align-start px-4 px-sm-6 py-5">
        <TitleFormWidget :title="title" small />

        <v-btn
          @click.prevent="$emit('close')"
          color="black"
          :small="xsOnly"
          absolute
          right
          icon
          top
        >
          <v-icon size="18">mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
    </v-sheet>
    <v-divider />

    <v-card-text class="px-4 px-sm-6 pb-0">
      <v-form @submit.prevent="submit" class="mt-3 mt-sm-4" ref="form">
        <div class="grid-list grid-list-4-columns">
          <TextFarmField
            v-model="people.name"
            class="span4"
            placeholder="Nome Completo"
            title="Nome"
          />

          <TextFarmField
            v-model="people.cpf_cnpj"
            @input="people.cpf_cnpj = maskCpfCnpj(people.cpf_cnpj)"
            class="span2"
            title="CPF/CNPJ"
            maxlength="18"
            only-number
          />

          <TextFarmField
            v-model="people.phone"
            @input="people.phone = maskPhone(people.phone)"
            class="span2"
            placeholder="(00) 00000-0000"
            title="Telefone"
            maxlength="15"
            only-number
          />

          <TextFarmField
            v-model="people.email"
            class="span2"
            placeholder="email@exemplo.com.br"
            title="E-mail"
          />

          <TextFarmField
            v-if="type === 'captivator'"
            v-model="people.creci"
            class="span2"
            title="CRECI"
          />

          <TextareaFarmField
            class="span4"
            v-model="people.observation"
            title="Observações"
            no-resize
          />
        </div>

        <v-sheet class="mt-3 mt-sm-4 fixed-bottom">
          <v-divider />

          <div class="d-flex justify-end py-4 px-6">
            <v-btn
              @click="$emit('close')"
              class="rounded-lg"
              :disabled="isLoading"
              color="#dddddd"
              outlined
            >
              <div class="black--text text-body-1 text-none font-weight-medium">
                Cancelar
              </div>
            </v-btn>

            <v-btn
              class="rounded-lg ml-2"
              color="orange"
              :disabled="isLoading"
              :loading="isLoading"
              type="submit"
              depressed
              dark
            >
              <v-icon color="white" size="20">mdi-content-save</v-icon>
              <div
                class="white--text text-body-1 text-none font-weight-medium ml-2"
              >
                Salvar
              </div>
            </v-btn>
          </div>
        </v-sheet>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import TitleFormWidget from "@/components/widgets/TitleForm.vue";
import TextFarmField from "@/components/fields/farm/Text.vue";
import TextareaFarmField from "@/components/fields/farm/Textarea.vue";
import ToGoBackDialog from "@/components/dialogs/ToGoBack.vue";
import maskCpfCnpj from "@/utils/maskCpfCnpj";
import maskPhone from "@/utils/maskPhone";
import { mapActions } from "vuex";

export default {
  components: {
    TitleFormWidget,
    TextFarmField,
    TextareaFarmField,
    ToGoBackDialog,
  },
  props: {
    type: {
      required: true,
      default: "captivator",
      validator: (v) => ["captivator", "owner", "contact"].includes(v),
    },
  },
  data: () => ({
    isLoading: false,
    people: {
      name: null,
      cpf_cnpj: null,
      phone: null,
      email: null,
      creci: null,
      observation: null,
      is_owner: null,
      is_captivator: null,
    },
  }),
  computed: {
    title() {
      const title = {
        captivator: "Captador",
        owner: "Proprietário",
      };
      return "Novo " + (title[this.type] || "Contato");
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    ...mapActions("peoples", ["insertPeople"]),
    async submit() {
      this.isLoading = true;

      const form = new FormData();

      for (let item in this.people) {
        if (this.people[item] || this.people[item] == 0) {
          form.append(item, this.people[item]);
        }
      }
      const r = await this.insertPeople(form);

      if (r) {
        this.$eventHub.$emit("snackBar", {
          icon: "mdi-account-plus",
          message: "Cadastro realizado com sucesso.",
          type: "success",
        });

        this.$emit("success");
      } else {
        this.$eventHub.$emit("snackBar", {
          icon: "mdi-alert-circle",
          message: "Erro ao cadastrar. Tente novamente.",
          type: "error",
        });
      }

      this.isLoading = false;
    },
    maskCpfCnpj,
    maskPhone,
  },
  created() {
    if (this.type === "owner") {
      this.people.is_owner = 1;
    } else if (this.type === "captivator") {
      this.people.is_captivator = 1;
    }
  },
};
</script>

<style lang="scss" scoped>
.form-card {
  border: 1px solid #e5e5e5 !important;
  border-radius: 14px !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1) !important;
  padding: 24px;
}

.grid-list {
  display: grid;
  gap: 12px;
}

.grid-list-4-columns {
  grid-template-columns: repeat(4, 1fr);
}

.span2 {
  grid-column: span 2;
}

.span3 {
  grid-column: span 3;
}

.span4 {
  grid-column: span 4;
}

.fixed-bottom {
  bottom: 0;
  margin-left: -24px;
  margin-right: -24px;
  position: sticky;

  @media screen and (max-width: 599.9px) {
    margin-left: -16px;
    margin-right: -16px;
  }
}
</style>
